/**
 * Class tokens for form fields inside the dashboard shell. Dependency-free on
 * purpose (see sidebar-classes.ts): route files and dialogs both import it and
 * nothing here may pull server code.
 *
 * 40px is the dashboard's field height: taller than the 36px toolbar and table
 * controls around it, shorter than the 44px account pages
 * (components/auth/auth-classes.ts), so a settings form reads as a form without
 * turning a dense screen into a signup page. Fields sit on the raised card
 * surface with one hairline and the per-brand `shadow-surface` lift.
 */

/** Overrides for BrandInput inside dashboard forms. */
export const FORM_INPUT_CLASS =
	"h-10 rounded-lg border-border/70 bg-card shadow-surface hover:border-border focus-visible:border-ring";

/** Overrides for BrandTextarea inside dashboard forms. */
export const FORM_TEXTAREA_CLASS =
	"rounded-lg border-border/70 bg-card shadow-surface hover:border-border focus-visible:border-ring";

/** Full recipe for a raw <input> that does not go through BrandInput. */
export const FORM_FIELD_CLASS =
	"flex h-10 w-full min-w-0 rounded-lg border border-border/70 bg-card px-3 text-sm text-foreground shadow-surface outline-none transition-[color,box-shadow] placeholder:text-muted-foreground hover:border-border focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid=true]:border-destructive";

/** Full recipe for a raw <textarea> that does not go through BrandTextarea. */
export const FORM_RAW_TEXTAREA_CLASS =
	"flex w-full min-w-0 resize-y rounded-lg border border-border/70 bg-card px-3 py-2.5 text-sm leading-6 text-foreground shadow-surface outline-none transition-[color,box-shadow] placeholder:text-muted-foreground hover:border-border focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50";

/** The action that submits a dashboard form, matched to the field height. */
export const FORM_BUTTON_CLASS = "h-10 rounded-lg px-4";

/** Prefix cell glued to the left of a field (the "@" before a handle). */
export const FORM_PREFIX_CLASS =
	"inline-flex items-center rounded-l-lg border border-r-0 border-border/70 bg-muted px-3 text-sm text-muted-foreground";
